import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var CertificadosService = /** @class */ (function () {
    function CertificadosService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    CertificadosService.prototype.getPasos = function () {
        return this._http.get("assets/json/pasos_cert.json")
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getSolicitante = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/solicitante', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.saveSolicitante = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/solicitante', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getRol = function (rol) {
        var params = {
            rol: rol
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/rol', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getPropiedades = function (rol, id, dir, num) {
        var params;
        if (rol && dir == undefined && num == undefined) {
            params = {
                rol: rol,
                id: id
            };
        }
        if (dir && num && rol == undefined) {
            params = {
                dir: dir,
                num: num
            };
        }
        console.log("params", params);
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/propiedades', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.savePropiedades = function (rol) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/propiedades', rol, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getTipo_cert = function () {
        var params = {};
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/tipos_certificados', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getCorviFM = function () {
        var params = {};
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/corvi', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    CertificadosService.prototype.getLinkByCod = function (codigo) {
        var params = { cod: codigo };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/linkByCod', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return CertificadosService;
}());
export { CertificadosService };
